// Shared framer-motion variants
export const easeSig = [0.76, 0, 0.24, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, delay: i * 0.08, ease: easeSig },
  }),
};

export const stagger = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.09 } },
};

export const lineReveal = {
  hidden: { y: "110%" },
  visible: (i = 0) => ({
    y: 0,
    transition: { duration: 1.1, delay: 0.15 + i * 0.12, ease: easeSig },
  }),
};

export const viewport = { once: true, amount: 0.25 };
